import React from 'react'

export default function Cubic() {
    return (
        <div>
            <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_171_2283)">
                    <path d="M16.9998 0L1.4165 8.5V25.6856L16.9998 34L32.5832 25.6856V8.59208L16.9998 0V0ZM28.2057 9.41517L17.0069 15.3907L5.85492 9.3075L16.9928 3.23142L28.2057 9.41517ZM4.24984 11.6592L15.5832 17.8401V30.0333L4.24984 23.987V11.6592ZM18.4165 30.0333V17.85L29.7498 11.8022V23.9856L18.4165 30.0333Z" fill="#BB0600" />
                </g>
                <defs>
                    <clipPath id="clip0_171_2283">
                        <rect width="34" height="34" fill="white" />
                    </clipPath>
                </defs>
            </svg>

        </div>
    )
}
